export function formattedPlayerName(team_name, player_name) {
	if (team_name === undefined || player_name === undefined) return "";
	const last_name = player_name.substring(
		player_name.lastIndexOf(" "),
		player_name.length
	);
	return team_name === "Purdue Football" ? last_name : player_name;
}
